module.exports = __webpack_public_path__ + "img/arrow-left.65752cf2.svg";